import { KeyCodes, RegistryInterface } from "silver";

const CLASS_KEYBOARD    = "-keyboard";
const CLASS_POINTER     = "-mouse";
const CLASS_TOUCHSCREEN = "-touch";
const CLASS_ROOT        = "device";

const INPUT_PREFERS_KEYBOARD = "input-prefers-keyboard";

export class InputMethodDetector {

	public constructor(
		private storage: RegistryInterface<boolean>,
		private document: Document = window.document
	) { }

	public listen() {
		this.document.body.classList.add(CLASS_ROOT);
		if (this.storage.get(INPUT_PREFERS_KEYBOARD) === false) {
			this.togglePrefersKeyboard(false);
		}
		if (typeof this.document.documentElement.ontouchstart !== "undefined") {
			this.document.body.classList.add(CLASS_TOUCHSCREEN);
		}
		this.document.body.addEventListener("mousedown", () => this.togglePrefersKeyboard(false));
		this.document.body.addEventListener("touchstart", () => this.togglePrefersKeyboard(false));
		this.document.body.addEventListener("keydown", ({ keyCode }) => {
			if (keyCode === KeyCodes.TAB) {
				this.togglePrefersKeyboard(true);
			}
		});
	}

	private togglePrefersKeyboard(prefersKeyboard: boolean): void {
		this.document.body.classList.toggle(CLASS_POINTER, !prefersKeyboard);
		this.document.body.classList.toggle(CLASS_KEYBOARD, prefersKeyboard);
		this.storage.set(INPUT_PREFERS_KEYBOARD, prefersKeyboard);
	}
}
